// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    PostIntelligentCoursePartnerHomePageTaskRankBody,
    BaseResponseListIntelligentPartnerHomePageCourseRank,
} from '../../../types';

/**
 * 榜单接口
 *
 * @export
 * @tags 智能陪练课程总览接口
 * @link [POST] /intelligentCoursePartner/homePage/taskRank
 */
export function postIntelligentCoursePartnerHomePageTaskRank(
    data: PostIntelligentCoursePartnerHomePageTaskRankBody
): Promise<BaseResponseListIntelligentPartnerHomePageCourseRank>;
export function postIntelligentCoursePartnerHomePageTaskRank(
    data: PostIntelligentCoursePartnerHomePageTaskRankBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseListIntelligentPartnerHomePageCourseRank>;
export function postIntelligentCoursePartnerHomePageTaskRank(
    data: PostIntelligentCoursePartnerHomePageTaskRankBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseListIntelligentPartnerHomePageCourseRank> {
    return request<PostIntelligentCoursePartnerHomePageTaskRankBody, never, never>(
        '/intelligentCoursePartner/homePage/taskRank',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postIntelligentCoursePartnerHomePageTaskRank',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练课程总览接口'],
        path: '/intelligentCoursePartner/homePage/taskRank',
        method: 'post',
    },
];
